// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"167":"d816b637","606":"cb2bdd31","609":"7250a904","850":"4fb0d4d0","926":"f3478ba6"}[chunkId] + ".chunk.js";
};